import React, { useEffect, useState } from 'react';
import { getPublicSales, updatePublicSaleModeration } from '../../api/public_sales';
import SalesAndPromotionsPanelControls from './SalesAndPromotionsPanelControls';
import SalesAndPromotionsPanelResults from './SalesAndPromotionsPanelResults';
import './SalesAndPromotions.scss';

const SalesAndPromotions = () => {
  const [filters, setFilters] = useState({ search: '', status: 'current', placement: 'all', visibility: 'all', offset: 0 });
  const [page, setPage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [savingIds, setSavingIds] = useState({});
  const [refresh, setRefresh] = useState(0);
  const updateFilters = updates => setFilters(previous => ({ ...previous, offset: 0, ...updates }));
  const reload = () => setRefresh(previous => previous + 1);
  const updateSale = async (sale, updates) => {
    setSavingIds(previous => ({ ...previous, [sale.id]: true }));
    try {
      const result = await updatePublicSaleModeration(sale, updates);
      setPage(previous => previous && { ...previous, sales: previous.sales.map(row => (row.id === sale.id ? { ...row, ...result } : row)) });
      reload();
      window.ALERT.success(
        updates.isHidden !== undefined
          ? updates.isHidden
            ? 'Sale hidden from creators.'
            : 'Sale restored to its creator schedule.'
          : updates.isFeatured
          ? 'Sale marked as featured.'
          : 'Sale removed from Featured Sales.'
      );
    } catch (err) {
      window.ALERT.error(err?.data?.error || err?.response?.data?.error || 'Could not update this sale. Please try again.');
      reload();
    } finally {
      setSavingIds(previous => ({ ...previous, [sale.id]: false }));
    }
  };
  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError('');
    const timer = setTimeout(() => {
      getPublicSales({ ...filters, limit: 25 })
        .then(result => {
          if (!active) return;
          setPage(result);
          setIsLoading(false);
        })
        .catch(() => {
          if (!active) return;
          setError('Could not load sales. Please try again.');
          setIsLoading(false);
        });
    }, 250);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [filters, refresh]);
  return (
    <main className='sales-and-promotions'>
      <header className='sales-header'>
        <div>
          <h1>Sales and Promotions</h1>
          <p>Manage public brand sales on the creator Latest tab.</p>
        </div>
        <button type='button' className='refresh-sales' onClick={reload} disabled={isLoading}>
          Refresh
        </button>
      </header>
      <SalesAndPromotionsPanelControls filters={filters} updateFilters={updateFilters} />
      {error && (
        <p className='sales-error' role='alert'>
          {error}{' '}
          <button type='button' onClick={reload}>
            Try again
          </button>
        </p>
      )}
      <SalesAndPromotionsPanelResults
        page={page}
        isLoading={isLoading}
        error={error}
        savingIds={savingIds}
        updateSale={updateSale}
        changePage={offset => setFilters(previous => ({ ...previous, offset }))}
      />
    </main>
  );
};
export default SalesAndPromotions;
